import React from "react";
import { ArrowsCirclepathIcon, TrashIcon } from "@navikt/aksel-icons";
import { Button } from "../../../../button/index.js";
const ItemButton = ({ action, onClick, id, title }) => {
    const Icon = action === "delete" ? TrashIcon : ArrowsCirclepathIcon;
    return (React.createElement(Button, { id: id, className: "navds-file-item__button", type: "button", variant: "tertiary-neutral", onClick: onClick, icon: React.createElement(Icon, { title: title }) }));
};
export default ItemButton;
//# sourceMappingURL=ItemButton.js.map